module.exports = __webpack_public_path__ + "img/V99.e43525e2.jpg";